import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/taskCreationWrapper/styles.scss';export default {
  "button": "_button_7hyg3_1",
  "form": "_form_7hyg3_12",
  "icon": "_icon_7hyg3_18",
  "text": "_text_7hyg3_22"
};